<div class="app-tag-list flex-start-center flex-wrap cursor-default">

  <!-- Tags -->
  <app-tag [hidden]="visibleItem" *ngFor="let tag of selectedTags; let i = index;" [tag]="tag" [label]="tag[tagLabelField]"
    [tagColor]="tag[tagColorField]" [tagHeight]="tagHeight" [fontSize]="fontSize" [isDeletable]="isDeleteable"
    (click)="handleTagClick(tag)" (appDelete)="onDelete($event)" [id]="'tags-' + i">
  </app-tag>

  <app-tag *ngFor="let tag of extraTags; let i = index;" [tag]="tag" [label]="tag[tagLabelField]" [tagHeight]="tagHeight"
    [textTruncate]="extraTagTruncate" [tagColor]="tag[tagColorField]" [fontSize]="fontSize"
    (click)="handleTagClick(tag)" [id]="'tags-' + i">
  </app-tag>

  <app-tag [hidden]="!visibleItem" *ngFor="let tag of visibleTags; let i = index;" [tag]="tag" [tagHeight]="tagHeight"
    [label]="tag[tagLabelField]" [tagColor]="tag[tagColorField]" [fontSize]="fontSize" [isDeletable]="isDeleteable"
    (click)="handleTagClick(tag)" (appDelete)="onDelete($event)" [id]="'tags-' + i">
  </app-tag>

  <app-content-overlay [hidden]="!visibleItem  || selectedTags?.length < visibleTags?.length" [showOnHover]="true">
    <ng-template appTemplate="item">
      <span class="font-color pointer">...</span>
    </ng-template>

    <ng-template appTemplate="overlay">
      <div class="flex-start-center flex-wrap tags-overlay p-2">
        <app-tag *ngFor="let tag of selectedTags; let i = index;" [tag]="tag" [label]="tag[tagLabelField]"
          [tagColor]="tag[tagColorField]" [tagHeight]="tagHeight" [fontSize]="fontSize"
          [stopPropagationOnDelete]="stopPropagationOnDelete" [isDeletable]="isDeleteable"
          (appDelete)="onDelete($event)" [id]="'tags-' + i">
        </app-tag>
      </div>
    </ng-template>
  </app-content-overlay>

  <!-- Add Tag Button -->
  <div [id]="buttonId" [hidden]="isCreateMode || !hasCreateOption || (maxLimit && selectedTags?.length >= maxLimit)"
    class="app-tag-create pointer app-tag flex-center-center"
    [ngClass]="{'create-tag-padding': !selectedTags?.length, 'disabled': disabled}"
    (click)="toggleCreateTag(true, $event)"
    [ngStyle]="{fontSize: fontSize + 'px', minWidth: !selectedTags?.length && addTagTitle? '65px': (fontSize + 8) + 'px', height: tagHeight ? tagHeight + 'px': ''}">
    <i class="fal fa-plus app-tag-create-btn"></i>

    <span class="font-12 font-400" [hidden]="selectedTags?.length"
      [ngClass]="{'ml-1': addTagTitle}">{{addTagTitle}}</span>
  </div>

  <!-- Create Tag AutoComplete -->
  <div [hidden]="!isCreateMode || !hasCreateOption" [ngStyle]="{ minWidth: inputBoxWidth }">
    <app-auto-complete id="ac-{{id}}" listId="ac-{{id}}-list" placeholder="Select tag" editableItemIdKey="_id"
      editFieldPlaceholder="Enter tag" field="name" value="" editFieldLabel="Create Tag" [fontSize]="12"
      [isSetPositionDynamically]="isSetPositionDynamically" [listItemFontSize]="12" [vPosition]="vPosition"
      [hPosition]="hPosition" [itemWidth]="itemWidth" [scrollHeight]="scrollHeight" [suggestions]="tagsResult"
      [closeOnSelection]="true" [hasEditableField]="true" [clearQueryOnClose]="true" [hasColorSelection]="true"
      [showSelectedValue]="false" [autoFocus]="isCreateMode" (appFocus)="showTagsSuggestion()"
      (appSelect)="onSelect($event)" (appSave)="onCreateTag($event)" (appUpdateItem)="onUpdateItem($event)"
      (appCompletedMethod)="onSearch($event)" (appClickOutside)="onClickOutside()">
      <ng-template let-item let-editItem="editItem" appTemplate="item">
        <div class="tag-item flex-between-center">
          <div>
            <span>{{ item?.name }} </span>
          </div>

          <div class="tag-item-action flex-end-center">
            <i *ngIf="!item.isNonDeletable" class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
            <i *ngIf="!item.isNonEditable" class="fas fa-trash p-1 mr-2" (click)="$event.stopPropagation(); deleteTag(item)"></i>
            <span class="color-circle" [ngStyle]="{backgroundColor: item?.color}"></span>
          </div>
        </div>
      </ng-template>
    </app-auto-complete>
  </div>
</div>
